import React from 'react';
import cx from 'classnames';
import { 
  FormGroup, InputGroup, FormControl
} from 'react-bootstrap';

import isEqual from 'is-equal';

import styles from './styles.module.scss';

class ProtectedInputField extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      password: '',
      current: false,
      editing: false,
      show: false
    };

    this._handleChange = this._handleChange.bind(this);

    this._toggleShowPassword = this._toggleShowPassword.bind(this);
    this._handleChangePassword = this._handleChangePassword.bind(this);
  }

  componentWillReceiveProps(nextProps){
    if(!isEqual(this.props, nextProps)){
      this.setState({
        current: nextProps.value.current
      })
    }
  }

  _toggleShowPassword(){
    this.setState({
      show: !this.state.show
    }, () => {
      this._triggerChange()
    })
  }

  _handleChangePassword(){
    this.setState({
      current: false
    }, () => {
      this._triggerChange()
    })
  }

  _handleChange(e){
    this.setState({
      password: e.target.value
    }, () => {
      this._triggerChange()
    });
  }

  _triggerChange(){
    if(this.props.onChange){
      this.props.onChange({
        value: this.state.password,
        current: this.state.current
      });
    }
  }

  render(){
    return (
      <div className={styles.passwordField}>
        <FormGroup className={cx(styles.formGroup, {
          [styles.currentPassword]: this.state.current,
          [styles.plainText]: this.state.show
        })}>
          {!this.state.current &&
            <InputGroup>
              <FormControl 
                type={this.state.show ? 'text' : 'password'}
                placeholder={this.props.placeholder}
                value={this.state.password}
                onChange={this._handleChange}/>
              <InputGroup.Text>
                <button onClick={this._toggleShowPassword}><i className={cx('lnr', 'lnr-eye')}></i></button>
              </InputGroup.Text>
            </InputGroup>
          }

          {this.state.current &&
            <InputGroup>
              <InputGroup.Text className={styles.readOnly}>
                <span>********</span>
              </InputGroup.Text>
              <InputGroup.Text>
                <button onClick={this._handleChangePassword}>{this.props.actionButton}</button>
              </InputGroup.Text>
            </InputGroup>
          }
        </FormGroup>

        {this.props.error && 
          <span className={styles.error}>{this.props.error}</span>
        }
      </div>
    );
  }
}

ProtectedInputField.defaultProps = {
  placeholder: "Enter password",
  actionButton: "CHANGE PASSWORD"
}

export default ProtectedInputField;